import React, { createContext, useState, useContext } from 'react';

// Create a Context
const ModalContext = createContext();

// Create a provider component
export const ModalProvider = ({ children }) => {
  const [openThisModal, setOpenThisModal] = useState(false);

  return (
    <ModalContext.Provider value={{ openThisModal, setOpenThisModal }}>
      {children}
    </ModalContext.Provider>
  );
};

// Create a custom hook for easier usage
export const useModal = () => useContext(ModalContext);
